import { render, staticRenderFns } from "./OutdatedPaidRefunded.vue?vue&type=template&id=5e10f1c1"
import script from "./OutdatedPaidRefunded.vue?vue&type=script&lang=js"
export * from "./OutdatedPaidRefunded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports